export enum EntitiesFiles {
    DOCUMENT_FRONT = 'DOCUMENT_FRONT',
    DOCUMENT_BACK = 'DOCUMENT_BACK',
    TITLE = 'TITLE',
    MEDICAL_LICENSE = 'MEDICAL_LICENSE',
    PROFILE_PHOTO = 'PROFILE'
}
